module.exports = __webpack_public_path__ + "static/media/next.5d987161.svg";